module.exports = __webpack_public_path__ + "img/board_layout_2.8d1e86a1.png";